.infoBox {
  width: 100%;
  background-color: var(--silver);
  padding: 2em;
  margin-bottom: 2em;
  display: grid;
  grid-template-columns: 0fr 1fr;

  & .title {
    grid-column: 1 / span 2;
    font-weight: 600;
  }

  & > div {
    min-height: 2em;
  }
}
